import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MenuItem from './MenuItem';
const getMenuItems = (items, closeMenu, onMouseEnter) => {
    return items.map((item, index) => (_jsx(MenuItem, Object.assign({}, item, { index: index, closeMenu: closeMenu, onMouseEnter: onMouseEnter }), index)));
};
export default getMenuItems;
